import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.slateGrey,
  textColorDark: colors.slateGrey,
  textColorLight: colors.white,
  cardRadius: '20px'
};
export default fiftyFiftyCard;